import BackendUploaderBase from 'components/partials/uploader/BackendUploaderBase'

export default {
  components: {
    BackendUploaderBase
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    url: {
      type: String
    },
    category: {
      type: String,
      default: null
    },
    factory: {
      type: Function,
      default: null
    },
    capture: {
      type: String
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reset () {
      this.$refs.uploader.reset()
    },
    upload () {
      this.$refs.uploader.upload()
    }
  }
}
